import { SERVICE_BOOKING_API, ServiceBookingApi } from '@app/_services/service-booking-api';
import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, ViewChild, AfterContentInit, AfterViewInit, Inject } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray } from '@angular/forms';
import { DateRange, DefaultMatCalendarRangeStrategy, MAT_DATE_RANGE_SELECTION_STRATEGY, MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import { OptionsEventService } from '@services/optionsEvent.service';

import * as _ from 'lodash';
import * as moment from 'moment';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TimeRangeViewComponent } from '../single-date-inlinePicker/componenets/timeRange-view/timeRange-view.component';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

@Component({
    selector: 'app-date-range-inlinePicker',
    templateUrl: './date-range-picker.component.html',
    styleUrls: ['./date-range-picker.component.scss'],
    providers: [
        {
            provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
            useClass: DefaultMatCalendarRangeStrategy,
        },
    ],
    standalone: true,
    imports: [
        MatDatepickerModule,
        NgIf,
        TimeRangeViewComponent,
        NgFor,
        MatButtonModule,
        MatIconModule,
        DatePipe,
        TranslateModule,
        NgxDaterangepickerMd
    ],
})
export class DateRangeInlinePickerComponent implements OnInit, AfterViewInit {
    constructor(private ref: ChangeDetectorRef, private fb: UntypedFormBuilder, private optionsEventService: OptionsEventService,
        @Inject(SERVICE_BOOKING_API) private bookingApi: ServiceBookingApi) {
        this.selected = {
            startDate: new Date(),
            endDate: new Date()
        }
    }

    //service item data
    @Input() product;
    @Input() timeType;

    @Input() disabledDates: string[];

    @Input() selected;

    @Input() range = this.fb.group({
        start: new Date("01/01/2020"), end: new Date("01/10/2020"),
        ranges: this.fb.array([]),
    });
    @Input() form;

    availableFrom: Date;

    availableTo: Date;

    weekday = [];

    currentYearMonth: Date;
    fetched: string[] = [];

    @Input() selectedRangeValue: DateRange<Date> | undefined;
    @Output() selectedRangeValueChange = new EventEmitter<DateRange<Date>>();

    selectedChange(m: any) {
        if (!this.selectedRangeValue?.start || this.selectedRangeValue?.end) {
            this.selectedRangeValue = new DateRange<Date>(m, null);
        } else {
            const start = this.selectedRangeValue.start;
            const end = m;
            if (end < start) {
                this.selectedRangeValue = new DateRange<Date>(end, start);
                this.range.patchValue({
                    start: new Date(end),
                    end: new Date(start),
                });
            } else {
                this.selectedRangeValue = new DateRange<Date>(start, end);
                this.range.patchValue({
                    start: new Date(start),
                    end: new Date(end),
                });
            }
        }

        this.selectedRangeValueChange.emit(this.selectedRangeValue);
    }

    onChangeRange(value) {
        if (!this.range.get('ranges').value) {
            this.range.get('ranges').setValue([]);
        }

        if (this.product.serviceType == "range_multi") {
            this.range.value.ranges.push(value);
        }
        this.range.patchValue({
            start: new Date(value.startDate),
            end: new Date(value.endDate),
        });

        this.optionsEventService.setOptionEvent(true);
    }

    deleteRange(index) {
        this.range.value.ranges.splice(index, 1);
        this.optionsEventService.setOptionEvent(true);
    }

    initDates = () => {
        this.weekday[0] = "Sunday";
        this.weekday[1] = "Monday";
        this.weekday[2] = "Tuesday";
        this.weekday[3] = "Wednesday";
        this.weekday[4] = "Thursday";
        this.weekday[5] = "Friday";
        this.weekday[6] = "Saturday";
        this.disabledDates = this.disabledDates || [];
        try {
            let minDate = new Date();
            if (this.product.availableFrom) {
                minDate = new Date(this.product.availableFrom);
                let today = new Date();
                if (minDate < today) {
                    minDate = today;
                }
            }
            this.availableFrom = minDate;

            if (this.product.availableTo) this.availableTo = new Date();
        } catch (error) {
            console.log(
                'Error initing Date range picker: ' + error?.toString()
            );
        }
    };

    ngOnInit(): void {
        this.initDates();
    }

    @ViewChild('calendar', { static: false }) calendar: MatCalendar<Date>;

    isSameMonthYear(dateA: Date, dateB: Date) {
        return dateA.getFullYear() == dateB.getFullYear() && dateA.getMonth() == dateB.getMonth();
    }

    getYearMonth(date: Date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}`;
    }

    getFullDate(date: Date) {
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${(date.getDate()).toString().padStart(2, '0')}`;
    }

    ngAfterViewInit() {
        this.disabledDates = this.disabledDates || [];
        this.currentYearMonth = new Date();
        this.calendar?.stateChanges?.subscribe((res) => {
            let activeDate = this.calendar.activeDate;
            if (this.fetched.includes(this.getYearMonth(activeDate))) return;
            if (!this.isSameMonthYear(activeDate, this.currentYearMonth)) {
                this.currentYearMonth = activeDate;
                let date = moment(activeDate);
                this.bookingApi.getDisabledDates(this.product._id, date.startOf('month').toISOString(), date.endOf('month').toISOString()).subscribe(
                    (result) => {
                        if (result.code == 200) {
                            this.disabledDates = this.disabledDates.concat(result.data);
                        }
                        this.fetched.push(this.getYearMonth(activeDate));
                        this.dateFilter = this.dateFilterFunction();
                    }
                );
            }
        });
        this.fetched.push(this.getYearMonth(new Date()));
        this.dateFilter = this.dateFilterFunction();
    }

    dateFilterFunction() {
        return (date: Date) => {
            if (!this.fetched.includes(this.getYearMonth(date))) return false;
            if (_.isEmpty(this.disabledDates)) return true;
            return !this.disabledDates.includes(this.getFullDate(date));
        };
    }

    //filter out non-work days and or booked days
    dateFilter = this.dateFilterFunction();

    //filter out non-work days and or booked days
    isInvalidDate = (date: Date) => {
        //let input = moment(date).format("Y-MM-DD");
        return !this?.disabledDates?.includes(moment(date).format("Y-MM-DD"));
    }
}
